<template>
  <!-- <HighlightedHeroVideo v-if="slugData" :page-data="slugData" hero-type=""
        :object-main-id="slugData.headerHighlightVideo" :breadcrumbs="false" @hero-ready="enableLayoutBuilder" /> -->

  <div class="page-wrapper" v-if="isAuthenticated">
    <AppHeader :data="{ title: 'Dashboard' }" />

    <div class="page-content-wrapper">
      <div class="left-side">
        <div class="mini-hero" v-if="slugData">
          <div class="title-wrapper">
            <h2 v-if="successPercentage > 0">Welcome back!</h2>
            <h2 v-else-if="slugData?.headerTitle">{{ slugData?.headerTitle }}</h2>
            <h2 v-else>Welcome!</h2>
          </div>
          <div v-html="slugData?.headerIntroText"></div>
        </div>

        <FpsScore v-if="getCurrentUser?.level == 1" />

        <div
          class="assessment-wrapper"
          v-if="getCurrentUser && getCurrentUser?.level != 1 && getCurrentUser?.userName"
        >
          <div class="assessment-item">
            <h3>Personal progress:</h3>
            <UserTrainingProgress />
            <UserTrainingCollection
              :key="`left-${getCurrentUser?.level}`"
              :paging="paging"
              :displayType="'list'"
              v-if="getCurrentUser?.level != 1"
            />
          </div>
        </div>

        <div class="link-block-wrapper">
          <div class="link-block-item">
            <div class="title-wrapper">
              <div class="link-block-item-icon">
                <v-Icon name="kennisbank-icon-blue" />
              </div>
              <h2 class="link-title">Knowledge bank</h2>
            </div>
            <div class="link-content-wrapper">
              <p>Discover articles and insights about all the themes of the scan.</p>
            </div>
            <div class="button-wrapper">
              <router-link class="button outline" to="/knowledge/articles">Discover</router-link>
            </div>
          </div>

          <div class="link-block-item green">
            <div class="title-wrapper">
              <div class="link-block-item-icon">
                <v-Icon name="howto-icon-green" />
              </div>
              <h2 class="link-title">How-to's</h2>
            </div>
            <div class="link-content-wrapper">
              <p>Practical tips and steps to get started immediately.</p>
            </div>
            <div class="button-wrapper">
              <router-link class="button outline" to="/knowledge/how-tos">Discover</router-link>
            </div>
          </div>

          <div class="link-block-item yellow">
            <div class="title-wrapper">
              <div class="link-block-item-icon">
                <v-Icon name="faq-icon-yellow" />
              </div>
              <h2 class="link-title">FAQs</h2>
            </div>
            <div class="link-content-wrapper">
              <p>Answers to the most frequently asked questions about the scan.</p>
            </div>
            <div class="button-wrapper">
              <router-link class="button outline" to="/knowledge/faqs"
                >Discover</router-link
              >
            </div>
          </div>
        </div>
      </div>
      <div class="right-side">
        <div
          class="assessment-wrapper"
          v-if="getCurrentUser && getCurrentUser?.level == 1 && getCurrentUser?.userName"
        >
          <div class="assessment-item">
            <h3>Personal progress:</h3>
            <UserTrainingProgress />
            <UserTrainingCollection
              :key="`right-${getCurrentUser?.level}`"
              :paging="paging"
              :displayType="'list'"
              v-if="getCurrentUser?.level == 1"
            />
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="page-wrapper" v-else-if="!isAuthenticated">
    <!-- <section class="section activate-account-section account-form-section">
            <div class="container">
                <div class="column-wrapper half-half">
                    <div class="column content">
                        <v-Icon class="logo" alt="KLANT - logo" name="logo" />

                    </div>
                    <div class="column form">
                        <h2 class="column-title">Login</h2>
                        <p class="subtitle">
                            Log in voor toegang
                        </p>
                        <LoginForm />
                    </div>
                </div>
            </div>
        </section> -->
    <HeroPage :page-data="slugData" />

    <PageLayoutBuilder :load-page-layout="true" :data="slugData" v-if="showPageBuilder">
      <template #section-zo-werkt-het="section">
        <section
          class="section zo-werkt-het"
          data-section-index="1"
          data-template-name="section-zo-werkt-het"
        >
          <span class="anchor" id="zo-werkt-het"></span>
          <span class="bg-el"></span>
          <div class="container">
            <div class="column-wrapper column-count-3 contains-templatecontent">
              <div
                class="column templatecontent picture"
                v-if="
                  section?.data?.elements[0]?.templateContent?.templateContentMedia?.mediaFirstImage
                "
              >
                <div class="inner-wrapper">
                  <div class="thumb">
                    <img
                      :src="
                        section.data.elements[0].templateContent.templateContentMedia
                          .mediaFirstImage.url
                      "
                    />
                  </div>
                </div>
              </div>
              <div class="column templatecontent content">
                <div class="inner-wrapper">
                  <div class="content-wrapper">
                    <div class="section-header-wrapper">
                      <h2 class="section-title">{{ section.data.title }}</h2>
                      <span class="section-subtitle">{{ section.data.subtitle }}</span>
                    </div>

                    <div
                      v-html="
                        section.data.elements[1].templateContent.templateContentFields.contentFirst
                      "
                    ></div>
                  </div>
                </div>
              </div>
              <div
                class="column templatecontent picture"
                v-if="
                  section?.data?.elements[2]?.templateContent?.templateContentMedia?.mediaFirstImage
                "
              >
                <div class="inner-wrapper">
                  <div class="thumb">
                    <img
                      :src="
                        section.data.elements[2].templateContent.templateContentMedia
                          .mediaFirstImage.url
                      "
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </template>
    </PageLayoutBuilder>
  </div>
</template>

<script setup>
import { computed, watch, ref } from 'vue'

// import LoginForm from '@/components/AuthForms/LoginForm.vue'

import HeroPage from '@/components/HeroPage/index.vue'
import PageLayoutBuilder from '@/components/PageLayoutBuilder/index.vue'
// import ContentGridCollection from '@/components/ContentGridCollection/index.vue'

import { useSlugData } from '@/composables/useSlugData'

import { useAuthenticationData } from '@/composables/useAuthenticationData'
import { useCurrentUserData } from '@/composables/useUserData'

import UserTrainingCollection from '@/components/UserTrainingCollection/index.vue'
import UserTrainingProgress from '@/components/UserTrainingProgress/index.vue'

import AppHeader from '@/components/AppHeader/index.vue'

import FpsScore from '@/components/FpsScore/index.vue'

import { useTrainingProgress } from '@/composables/userTrainingProgress'

const { successPercentage } = useTrainingProgress()

// const calendarObj = {
//     "relatedContent": {
//         "type": "TemplateContent",
//         "displayItemsAmount": 10,
//         "templateId": "abd0c428-2a7a-40ff-8ecb-980c42125522"
//     },
// };

// const calendarFilterObj = {
//     orderBy: {
//         orderByField: 'publicationDate',
//         orderDesc: false
//     },
// }

const isAuthenticated = computed(() => {
  return useAuthenticationData().data.value.isAuthenticated
})

// const loadPageLayout = ref(false);
const showPageBuilder = ref(true)

const { getCurrentUser } = useCurrentUserData()

// const testUser = ref({
//     level: 1
// });

const paging = {
  pageNumber: 1,
  pageSize: 50
}

function loadCorrectPage() {
  if (isAuthenticated.value) {
    return 'home'
  } else {
    return 'home-not-logged-in'
  }
}

//true : false
const { getData, slugData } = useSlugData(loadCorrectPage())

getData()

//Watch auth and refresh slugData
watch([() => isAuthenticated.value, () => getCurrentUser.value], () => {
  showPageBuilder.value = false

  //true : false
  const { getData } = useSlugData(loadCorrectPage())

  getData()
})

//Watch slugData change and enable layout builder
watch(
  () => slugData.value,
  () => {
    showPageBuilder.value = true
  }
)

// let test = 2.557;

// console.log(test.toFixed(2));
</script>

<style lang="scss" scoped>
// @import styles
@import './index.scss';
</style>
